import { useState, useEffect, useRef } from 'react';
import html2canvas from 'html2canvas';
import { supabase } from '../../supabaseClient';

function seteDiasAtras() {
  const d = new Date();
  d.setDate(d.getDate() - 7);
  return d.toISOString();
}

function fmt(n) {
  if (!n && n !== 0) return '0';
  if (n >= 1000) return `${(n / 1000).toFixed(1).replace('.0', '')}k`;
  return n.toString();
}

const ITENS = [
  {
    key: 'checkins',
    getValor: m => m.totalCheckins,
    getSemana: m => m.checkinsSemanais,
    label: 'momentos de presença',
    desc: 'Cada vez que alguém faz seu check-in diário',
  },
  {
    key: 'reflexoes',
    getValor: m => m.totalReflexoes,
    getSemana: m => m.reflexoesSemanais,
    label: 'reflexões compartilhadas',
    desc: 'Pensamentos autênticos publicados anonimamente',
  },
  {
    key: 'empatia',
    getValor: m => m.totalEmpatia,
    getSemana: m => m.empatiaSemanais,
    label: 'conexões de empatia',
    desc: 'Vezes que nos identificamos umas com as outras',
  },
];

const IconShare = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
    <polyline points="16 6 12 2 8 6" />
    <line x1="12" y1="2" x2="12" y2="15" />
  </svg>
);

// Card de compartilhamento — inline styles para html2canvas
function ComunidadeShareCard({ metricas, cardRef }) {
  const s = {
    card: {
      width: 360, height: 640,
      background: 'linear-gradient(160deg, #2f2b5f 0%, #1a1838 100%)',
      display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
      padding: '36px 32px 32px',
      position: 'relative', overflow: 'hidden',
      fontFamily: "'DM Sans', sans-serif",
      boxSizing: 'border-box',
    },
    blob1: {
      position: 'absolute', borderRadius: '50%', pointerEvents: 'none',
      width: 280, height: 280,
      background: 'radial-gradient(circle, rgba(123,94,167,0.35) 0%, transparent 70%)',
      top: -60, right: -80,
    },
    blob2: {
      position: 'absolute', borderRadius: '50%', pointerEvents: 'none',
      width: 220, height: 220,
      background: 'radial-gradient(circle, rgba(111,174,143,0.2) 0%, transparent 70%)',
      bottom: 40, left: -60,
    },
    blob3: {
      position: 'absolute', borderRadius: '50%', pointerEvents: 'none',
      width: 160, height: 160,
      background: 'radial-gradient(circle, rgba(255,255,255,0.04) 0%, transparent 70%)',
      top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
    },
    header: {
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      position: 'relative', zIndex: 1,
    },
    headerLeft: { display: 'flex', alignItems: 'center', gap: 7 },
    logoText: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: 17, fontWeight: 500, color: 'rgba(255,255,255,0.9)', letterSpacing: '0.01em',
    },
    ig: { display: 'flex', alignItems: 'center', gap: 4 },
    igHandle: { fontSize: 11, color: 'rgba(255,255,255,0.35)', letterSpacing: '0.01em' },
    body: {
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      position: 'relative', zIndex: 1, flex: 1,
      justifyContent: 'center', padding: '24px 0 16px',
    },
    label: {
      fontSize: 10, fontWeight: 600, letterSpacing: '0.13em', textTransform: 'uppercase',
      color: 'rgba(255,255,255,0.45)', margin: '0 0 16px',
    },
    divider: { width: 36, height: 1, background: 'rgba(255,255,255,0.2)', margin: '0 auto 24px' },
    statsRow: {
      display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
      width: '100%', gap: 8, marginBottom: 24,
    },
    statCol: {
      flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6,
    },
    statNum: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: 42, fontWeight: 600, color: '#a990d0', lineHeight: 1,
    },
    statLabel: {
      fontSize: 10, fontWeight: 400, color: 'rgba(255,255,255,0.55)',
      textAlign: 'center', lineHeight: 1.35,
    },
    statDivider: { width: 1, height: 56, background: 'rgba(255,255,255,0.12)', alignSelf: 'center' },
    divider2: { width: 36, height: 1, background: 'rgba(255,255,255,0.2)', margin: '0 auto 18px' },
    tagline: {
      fontSize: 12, fontWeight: 400, color: 'rgba(255,255,255,0.45)',
      textAlign: 'center', lineHeight: 1.6, margin: 0, fontStyle: 'italic',
    },
    footer: { position: 'relative', zIndex: 1, textAlign: 'center' },
    footerCta: { fontSize: 13, fontWeight: 500, color: 'rgba(255,255,255,0.6)', margin: '0 0 5px' },
    footerUrl: { fontSize: 12, fontWeight: 600, color: '#a990d0', margin: 0 },
  };

  return (
    <div ref={cardRef} style={s.card}>
      <div style={s.blob1} />
      <div style={s.blob2} />
      <div style={s.blob3} />

      <div style={s.header}>
        <div style={s.headerLeft}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#a990d0">
            <path d="M12 2 L13.8 10.2 L22 12 L13.8 13.8 L12 22 L10.2 13.8 L2 12 L10.2 10.2 Z"/>
          </svg>
          <span style={s.logoText}>Clube do Eu</span>
        </div>
        <div style={s.ig}>
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
            <circle cx="12" cy="12" r="4"/>
            <circle cx="17.5" cy="6.5" r="0.5" fill="rgba(255,255,255,0.3)" stroke="none"/>
          </svg>
          <span style={s.igHandle}>@oclubedoeu</span>
        </div>
      </div>

      <div style={s.body}>
        <p style={s.label}>Nossa Comunidade</p>
        <div style={s.divider} />
        <div style={s.statsRow}>
          {metricas && ITENS.map((item, i) => (
            <div key={item.key} style={{ display: 'flex', flex: 1, alignItems: 'stretch' }}>
              {i > 0 && <div style={s.statDivider} />}
              <div style={{ ...s.statCol, flex: 1 }}>
                <span style={s.statNum}>{fmt(item.getValor(metricas))}</span>
                <span style={s.statLabel}>{item.label}</span>
              </div>
            </div>
          ))}
        </div>
        <div style={s.divider2} />
        <p style={s.tagline}>A comunidade onde exploramos os vários eus que existem dentro de nós.</p>
      </div>

      <div style={s.footer}>
        <p style={s.footerCta}>Comece sua jornada →</p>
        <p style={s.footerUrl}>app.oclubedoeu.com.br</p>
      </div>
    </div>
  );
}

export default function MetricasComunidade() {
  const [metricas, setMetricas] = useState(null);
  const [ativo, setAtivo] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [gerando, setGerando] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    async function buscar() {
      const inicio = seteDiasAtras();
      const [
        { count: totalCheckins },
        { count: checkinsSemanais },
        { count: totalReflexoes },
        { count: reflexoesSemanais },
        { count: totalEmpatia },
        { count: empatiaSemanais },
      ] = await Promise.all([
        supabase.from('daily_logs').select('*', { count: 'exact', head: true }).eq('completed', true),
        supabase.from('daily_logs').select('*', { count: 'exact', head: true }).eq('completed', true).gte('date', inicio.slice(0, 10)),
        supabase.from('reflexoes_anonimas').select('*', { count: 'exact', head: true }),
        supabase.from('reflexoes_anonimas').select('*', { count: 'exact', head: true }).gte('created_at', inicio),
        supabase.from('me_identifico').select('*', { count: 'exact', head: true }),
        supabase.from('me_identifico').select('*', { count: 'exact', head: true }).gte('created_at', inicio),
      ]);
      setMetricas({
        totalCheckins: totalCheckins || 0,
        checkinsSemanais: checkinsSemanais || 0,
        totalReflexoes: totalReflexoes || 0,
        reflexoesSemanais: reflexoesSemanais || 0,
        totalEmpatia: totalEmpatia || 0,
        empatiaSemanais: empatiaSemanais || 0,
      });
    }
    buscar();
  }, []);

  // Gera preview assim que os dados chegam
  useEffect(() => {
    if (!metricas || !cardRef.current) return;
    let cancelled = false;
    setGerando(true);

    const gerar = async () => {
      try { await document.fonts.ready; } catch {}
      await new Promise(r => setTimeout(r, 120));
      if (cancelled || !cardRef.current) { setGerando(false); return; }
      try {
        const scale = Math.min(window.devicePixelRatio || 2, 2);
        const canvas = await html2canvas(cardRef.current, {
          scale,
          useCORS: true,
          allowTaint: true,
          backgroundColor: '#2f2b5f',
          logging: false,
          foreignObjectRendering: false,
        });
        if (!cancelled) setPreviewUrl(canvas.toDataURL('image/png'));
      } catch {
        // sem preview, mas botão ainda aparece
      } finally {
        if (!cancelled) setGerando(false);
      }
    };

    gerar();
    return () => { cancelled = true; };
  }, [metricas]);

  const handleShare = async () => {
    if (!previewUrl) return;
    try {
      const res = await fetch(previewUrl);
      const blob = await res.blob();
      const file = new File([blob], 'comunidade-clube-do-eu.png', { type: 'image/png' });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: 'Nossa Comunidade — Clube do Eu' });
        return;
      }
      handleDownload();
    } catch {
      handleDownload();
    }
  };

  const handleDownload = () => {
    if (!previewUrl) return;
    const link = document.createElement('a');
    link.download = 'comunidade-clube-do-eu.png';
    link.href = previewUrl;
    link.click();
  };

  if (!metricas) return null;

  const itemAtivo = ITENS.find(i => i.key === ativo);

  return (
    <>
      {/* Card off-screen para captura */}
      <div style={{ position: 'absolute', overflow: 'hidden', width: 0, height: 0, top: 0, left: 0, pointerEvents: 'none', zIndex: -1 }}>
        <ComunidadeShareCard metricas={metricas} cardRef={cardRef} />
      </div>

      {/* Métricas inline */}
      <div className="metricas-inline">
        {ITENS.map(item => (
          <button
            key={item.key}
            className={`metrica-col${ativo === item.key ? ' ativo' : ''}`}
            onClick={() => setAtivo(ativo === item.key ? null : item.key)}
          >
            <span className="metrica-num">{fmt(item.getValor(metricas))}</span>
            <span className="metrica-label">{item.label}</span>
          </button>
        ))}
      </div>

      {itemAtivo && (
        <div className="metrica-reveal">
          <p className="metrica-reveal-desc">{itemAtivo.desc}</p>
          {itemAtivo.getSemana(metricas) > 0 && (
            <p className="metrica-reveal-semana">+{itemAtivo.getSemana(metricas)} esta semana</p>
          )}
        </div>
      )}

      <button
        className="btn btn-ghost metricas-gerar"
        onClick={() => setShowPreview(true)}
        disabled={gerando || !previewUrl}
      >
        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7 }}>
          <IconShare />
          {gerando ? 'Gerando…' : 'Compartilhar estatísticas'}
        </span>
      </button>

      {/* Preview / compartilhamento */}
      {showPreview && previewUrl && (
        <div className="oracle-preview-backdrop" onClick={() => setShowPreview(false)}>
          <div className="oracle-preview-box" onClick={e => e.stopPropagation()}>
            <p className="oracle-preview-hint">Toque e segure para salvar · ou compartilhe abaixo</p>
            <img
              src={previewUrl}
              alt="Card da comunidade"
              className="oracle-preview-img"
              draggable={false}
              onClick={handleShare}
              style={{ cursor: 'pointer' }}
            />
            <button
              className="btn btn-primary"
              style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
              onClick={handleShare}
            >
              <IconShare />
              Compartilhar / Salvar imagem
            </button>
            <button className="btn btn-ghost oracle-preview-close" onClick={() => setShowPreview(false)}>
              Fechar
            </button>
          </div>
        </div>
      )}
    </>
  );
}
